import React, { useState, useEffect } from 'react';
import { Sidebar, Header, CustomSelect, LoadingPage } from '../common';
import { CustomDatePicker, InputBox } from './common/';
import { ElectricityTable } from './tables';
import { getAllUser, getAllBuilding, getUtilities, getSnapshot, getSnapshotDate, saveSnapshot, saveUtilities} from "./ApiService";

import InformationCircleIcon from "./assets/information-circle.svg";
import ExclamationCircleIcon from "./assets/exclamation-circle.svg";
import Uploading from "./assets/uploading.svg"
import UploadComplete from "./assets/upload-complete.svg"

import '../styles/billingPageStyles.css';
import '../styles/styles.css';
import './Electricity.css';

const convertString2Int = (string) => {
    return parseInt(String(string).replace(/,/g, ''), 10) || 0
};
const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};
const convertRound = (value) => {
    return Math.round(value);
};
const priceUnitCutting = (value) => {
    return Math.floor(value / 10) * 10;
};
const safeValue = (value) => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
        return 0;
    }
    return value;
}

const Electricity = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 7);
    const [date, setDate] = useState(formattedDate);
    const [allowedMonths, setAllowedMonths] = useState([formattedDate]);

    const [isUploading, setIsuploading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const role = sessionStorage.getItem("role");
    const [users, setUsers] = useState(sessionStorage.getItem("userName"));
    const [userId, setUserId] = useState("");

    const buildingData = JSON.parse(sessionStorage.getItem("building")) || [];
    const [buildings, setBuildings] = useState(buildingData.reduce((acc, item) => {
        acc[item.id] = item.buildingName;
        return acc;
    }, {}));
    const [buildingId, setBuildingId] = useState(sessionStorage.getItem("lastBuilding") || Object.keys(buildings)[0] ||  null);
    const hasBuilding = buildingId !== null;

    const [beforeSaveTableData, setBeforeSaveTableData] = useState({
        date: date,
        buildingUtilitiesInfo: {
            buildingElecPrice: 0,
            buildingElecFund: 0,
            buildingElecTV: 0,
        },
        roomUtilitiesInfoList: [],
    });
    const [tableData, setTableData] = useState({
        date: date,
        buildingUtilitiesInfo: {
            buildingElecPrice: 0,
            buildingElecFund: 0,
            buildingElecTV: 0,
        },
        roomUtilitiesInfoList: [],
    });

    const generateTableData = (elecData) => {
        const buildingUtilitiesInfo = elecData.buildingUtilitiesInfo;
        const roomUtilitiesInfoList = elecData.roomUtilitiesInfoList;

        const totalRoomPrivateArea = roomUtilitiesInfoList
            .filter(room => room.roomStatus === "CONTRACT")
            .reduce((sum, room) => sum + room.roomPrivateArea, 0);
        
        const processedRoomInfoList = roomUtilitiesInfoList.map(room => {
            if (room.roomStatus === "CONTRACT") {
                const privateAreaRatio = safeValue(room.roomPrivateArea / totalRoomPrivateArea);

                const elecPrice = convertRound(buildingUtilitiesInfo.buildingElecPrice * privateAreaRatio);
                const elecVAT = priceUnitCutting(buildingUtilitiesInfo.buildingElecPrice * privateAreaRatio) * 0.1;
                const elecFund = convertRound(buildingUtilitiesInfo.buildingElecFund * privateAreaRatio);
                const elecTV = convertRound(buildingUtilitiesInfo.buildingElecTV * privateAreaRatio);

                return {
                    ...room,
                    privateAreaRatio,
                    elecPrice,
                    elecVAT,
                    elecFund,
                    elecTV,
                    totalTaxPrice: elecPrice + elecVAT,
                    totalTaxFreePrice: elecFund + elecTV,
                    totalTaxAndTaxFreePrice: elecPrice + elecVAT + elecFund + elecTV,
                    totalPrice: priceUnitCutting(elecPrice + elecVAT + elecFund + elecTV + room.roomElecChangePrice),
                };
            } else {
                return {
                    ...room,
                    privateAreaRatio:0,
                    elecPrice:0,
                    elecVAT:0,
                    elecFund:0,
                    elecTV:0,
                    totalTaxPrice:0,
                    totalTaxFreePrice:0,
                    totalTaxAndTaxFreePrice:0,
                    totalPrice:0
                };
            }
        });

        return {
            date : date,
            buildingUtilitiesInfo,
            roomUtilitiesInfoList : processedRoomInfoList
        }
    }
    const handleValueChange = (field, newValue) => {
        setTableData(prevData => ({
            ...prevData,
            buildingUtilitiesInfo: {
                ...prevData.buildingUtilitiesInfo,
                [field]: newValue
            }
        }));
    };
    const updateRoomUtilitiesInfoList = (roomId, field, newValue) => {
        setTableData(prevData => ({
            ...prevData,
            roomUtilitiesInfoList: prevData.roomUtilitiesInfoList.map(room => 
                room.roomId === roomId ? {
                    ...room,
                    [field]: newValue
                } : room
            )
        }));
    };

    useEffect(() => {
        if (role === "ADMIN") {
            getAllUser(setUsers)
        }
    }, [])

    useEffect(() => {
        if (role === "ADMIN") {
            getAllBuilding(userId, buildings, setBuildings, setBuildingId);
        }
    }, [userId, buildings])

    // tableData 변경시 snapshot과 변경데이터 서버에 전송
    useEffect(() => {
        const generatedData = generateTableData(tableData)
        
        if (JSON.stringify(generatedData) !== JSON.stringify(beforeSaveTableData)) {
            setBeforeSaveTableData(generatedData)
            setTableData(generatedData);
            
            setIsuploading(true);

            const handleSaveUtilities = async () => {
                await saveUtilities(date, buildingId, generatedData);
            };
            const handleSaveSnapshot = async () => {
                await saveSnapshot(date, buildingId, generatedData, "elec");
            };
            if (date === formattedDate) {
                Promise.all([handleSaveUtilities(), handleSaveSnapshot()])
                    .then(() => {
                        setIsuploading(false);
                    })
                    .catch(error => {
                        // console.log("저장중 에러발생: ", error);
                        setIsuploading(false);
                    });
            } else {
                handleSaveSnapshot()
                    .then(() => {
                        setIsuploading(false);
                    })
                    .catch(error => {
                        // console.log("저장중 에러발생: ", error);
                        setIsuploading(false);
                    });
            };
        }
    }, [tableData])

    // buildingId와 date로 서버에서 데이터 불러오기
    useEffect(() => {
        if (date === formattedDate) {
            getUtilities(buildingId, date, setIsLoading, setTableData, generateTableData); 
        } else {
            getSnapshot("elec", buildingId, date, setIsLoading, setTableData);
        }
    }, [buildingId, date]);

    useEffect(() => {
        getSnapshotDate(buildingId, setAllowedMonths);
    }, [buildingId]);

    if (isLoading) {
        return <LoadingPage />;
    }
    return(
        <div className="page">
            <Sidebar />
            <div className="sideBarElseContainer">
                <Header pageName="전기세 계산기"/>
                <div className="headerElseContainer">
                    <div className="billingPageContainer">
                        <div className="billingPageLeftContainer">
                            {role === "ADMIN" ? (
                                <CustomSelect placeholder="사용자를 선택해주세요" customSelectList={users} parentCustomSelect={userId} setParentCustomSelect={setUserId} />
                            ) : (<></>)}
                            <CustomSelect placeholder="건물을 선택해주세요" customSelectList={buildings} parentCustomSelect={buildingId} setParentCustomSelect={setBuildingId} />
                            <div className="saving-status-container">
                                {isUploading ? (
                                    <div className="uploading-status-container">
                                        <img src={Uploading} alt="uploading" className='uploading' />
                                        <span className="uploadingSpan">
                                            저장중...
                                        </span>
                                    </div>
                                ) : (
                                    <div className="upload-complete-status-container">
                                        <img src={UploadComplete} alt="upload-complete" className="uploadComplete"/>
                                        <span className="uploadCompleteSpan">
                                            저장완료!
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <CustomDatePicker placeholder="년월을 선택해주세요" allowedMonths={allowedMonths} date={date} setDate={setDate} />
                    </div>
                    <div className="billingTopContainer">
                        <div className="billingTopInfo">
                            <img src={InformationCircleIcon} alt="Information" className='informationCircle' />
                            아래 항목을 입력하여 호실별 청구금액을 계산할 수 있어요
                        </div>
                        <div className='elecTaxContainer'>
                            <div className="taxTag">과세</div>
                            <InputBox prefix="전기요금" placeholder="0" postfix="원" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingElecPrice || 0)} setValue={(newValue) => handleValueChange("buildingElecPrice", newValue)}/>
                            <InputBox prefix="부가가치세" placeholder="0" postfix="원" value={convertInt2String(Math.floor(tableData["buildingUtilitiesInfo"].buildingElecPrice * 0.1) || 0)} disabled={true} />
                        </div>
                        <div className='elecTaxFreeContainer'>
                            <div className="taxFreeTag">비과세</div>
                            <InputBox prefix="전력기금" placeholder="0" postfix="원" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingElecFund || 0)} setValue={(newValue) => handleValueChange("buildingElecFund", newValue)} />
                            <InputBox prefix="TV 수신료" placeholder="0" postfix="원" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingElecTV || 0)} setValue={(newValue) => handleValueChange("buildingElecTV", newValue)} />
                        </div>
                    </div>
                    <div className="billingBtmContainer">
                        <div className="billingBtmInfo">
                            {sessionStorage.getItem("role") === "GUEST" ? (
                                <div className="billingBtmInfoExplain">
                                    <img src={ExclamationCircleIcon} alt="Information" className='exclamationCircle' />
                                    로그인하시면 계산 내용을 저장할 수 있습니다.
                                </div>
                            ) : (<></>)}
                        </div>
                        <div className="billingRoomCalculator">
                            <ElectricityTable hasBuilding={hasBuilding} roomInfo={tableData.roomUtilitiesInfoList} setRoomInfo={updateRoomUtilitiesInfoList} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Electricity;